import { render, staticRenderFns } from "./_FavoriteStar.vue?vue&type=template&id=30e48bbe"
import script from "./_FavoriteStar.vue?vue&type=script&lang=js"
export * from "./_FavoriteStar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports